module.exports = __webpack_public_path__ + "img/icon-profile.420bfa7b.svg";